import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import KeyCloak from "@/common/module/keyCloak";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "insights",
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "@/components/atomic/pages/insights/index.vue"
      ),
    meta: {
      showDatePicker: false,
      showBetaTag: false,
      breadcrumb: "",
    },
  },
  {
    path: "/receita",
    name: "revenue",
    component: () =>
      import(
        /* webpackChunkName: "revenue" */ "@/components/atomic/pages/revenue/index.vue"
      ),
    meta: {
      showDatePicker: true,
      breadcrumb: "Pedidos assistidos",
    },
  },
  {
    path: "/base-de-pessoas",
    name: "base",
    component: () =>
      import(
        /* webpackChunkName: "base" */ "@/components/atomic/pages/base/index.vue"
      ),
    meta: {
      showDatePicker: true,
      showBetaTag: false,
      breadcrumb: "",
    },
  },
  {
    path: "/performance/email",
    name: "emailEngagement",
    component: () =>
      import(
        /* webpackChunkName: "emailEngagement" */ "@/components/atomic/pages/engagement/email/index.vue"
      ),
    meta: {
      showDatePicker: true,
      showBetaTag: false,
      breadcrumb: "",
    },
    beforeEnter: (to, from) => KeyCloak.permissionPage("performance_e-mail"),
  },
  {
    path: "/performance/geral",
    name: "generalEngagement",
    component: () =>
      import(
        /* webpackChunkName: "generalEngagement" */ "@/components/atomic/pages/engagement/general/index.vue"
      ),
    meta: {
      showDatePicker: true,
      showBetaTag: true,
      breadcrumb: "",
    },
  },
  {
    path: "/performance/whatsapp",
    name: "whatsappEngagement",
    component: () =>
      import(
        /* webpackChunkName: "whatsappEngagement" */ "@/components/atomic/pages/engagement/whatsapp/index.vue"
      ),
    meta: {
      showDatePicker: true,
      showBetaTag: false,
      breadcrumb: "",
    },
    beforeEnter: (to, from) => KeyCloak.permissionPage("performance_whatsApp"),
  },
  {
    path: "/performance/sms",
    name: "smsEngagement",
    component: () =>
      import(
        /* webpackChunkName: "smsEngagement" */ "@/components/atomic/pages/engagement/sms/index.vue"
      ),
    meta: {
      showDatePicker: true,
      showBetaTag: true,
      breadcrumb: "",
    },
    beforeEnter: (to, from) =>
      KeyCloak.permissionPage("performance_sms") ||
      KeyCloak.featureFlag("ENV_WAKE_STORE"),
  },
  {
    path: "/performance/app",
    name: "appEngagement",
    component: () =>
      import(
        /* webpackChunkName: "appEngagement" */ "@/components/atomic/pages/engagement/app/index.vue"
      ),
    meta: {
      showDatePicker: true,
      breadcrumb: "",
    },
  },
  {
    path: "/performance/app-push",
    name: "appPushQuicksight",
    component: () =>
      import(
        /* webpackChunkName: "appPushQuicksight" */ "@/components/atomic/pages/quicksight/appPush/index.vue"
      ),
    meta: {
      showDatePicker: false,
      breadcrumb: "",
    },
    beforeEnter: (to, from) => KeyCloak.permissionPage("performance_app_push"),
  },
  {
    path: "/performance/web-push",
    name: "webPushQuicksight",
    component: () =>
      import(
        /* webpackChunkName: "webPushQuicksight" */ "@/components/atomic/pages/quicksight/webPush/index.vue"
      ),
    meta: {
      showDatePicker: false,
      breadcrumb: "",
    },
    beforeEnter: (to, from) => KeyCloak.permissionPage("performance_web_push"),
  },
  {
    path: "/performance/lightbox",
    name: "lightboxQuicksight",
    component: () =>
      import(
        /* webpackChunkName: "lightboxQuicksight" */ "@/components/atomic/pages/quicksight/lightBox/index.vue"
      ),
    meta: {
      showDatePicker: false,
      breadcrumb: "",
    },
    beforeEnter: (to, from) => KeyCloak.permissionPage("performance_lightbox"),
  },
  {
    path: "/performance/push-optin",
    name: "pushOptinQuicksight",
    component: () =>
      import(
        /* webpackChunkName: "pushOptinQuicksight" */ "@/components/atomic/pages/quicksight/pushOptin/index.vue"
      ),
    meta: {
      showDatePicker: false,
      breadcrumb: "",
    },
    beforeEnter: (to, from) =>
      KeyCloak.permissionPage("performance_push_optin"),
  },
  {
    path: "/performance/onsite-message",
    name: "onsiteMessageQuicksight",
    component: () =>
      import(
        /* webpackChunkName: "onsiteMessageQuicksight" */ "@/components/atomic/pages/quicksight/onsiteMessage/index.vue"
      ),
    meta: {
      showDatePicker: false,
      breadcrumb: "",
    },
    beforeEnter: (to, from) =>
      KeyCloak.permissionPage("performance_onsite_message"),
  },
  {
    path: "/performance/jornadas",
    name: "journeyQuicksight",
    component: () =>
      import(
        /* webpackChunkName: "journeyQuicksight" */ "@/components/atomic/pages/quicksight/journey/index.vue"
      ),
    meta: {
      showDatePicker: false,
      breadcrumb: "",
    },
  },
  {
    path: "/audiencias",
    name: "audiences",
    component: () =>
      import(
        /* webpackChunkName: "audiences" */ "@/components/atomic/pages/audiences/index.vue"
      ),
    meta: {
      showDatePicker: false,
      breadcrumb: "",
    },
    children: [
      {
        path: "",
        name: "your-audiences",
        component: () =>
          import(
            /* webpackChunkName: "yourAudiences" */ "@/components/atomic/pages/audiences/yourAudiences/index.vue"
          ),
        meta: {
          showBetaTag: false,
        },
      },
      {
        path: "bemax",
        name: "pre-defined-audiences",
        component: () =>
          import(
            /* webpackChunkName: "preDefinedAudience" */ "@/components/atomic/pages/audiences/preDefinedAudience/index.vue"
          ),
        meta: {
          showBetaTag: false,
        },
      },
      {
        path: "criar-audiencia",
        name: "create-audience",
        component: () =>
          import(
            /* webpackChunkName: "createAudience" */ "@/components/atomic/pages/audiences/createAudience/index.vue"
          ),
        meta: {
          showBetaTag: false,
        },
      },
    ],
  },
  {
    path: "/studio",
    name: "studio",
    component: () =>
      import(
        /* webpackChunkName: "studio" */ "@/components/atomic/pages/studio/index.vue"
      ),
    meta: {
      showDatePicker: false,
      showBetaTag: true,
      breadcrumb: "",
    },
    children: [
      {
        path: "",
        name: "list-model",
        component: () =>
          import(
            /* webpackChunkName: "listModel" */ "@/components/atomic/pages/studio/whatsapp/listModel/index.vue"
          ),
      },
      {
        path: "criar-modelo",
        name: "create-model",
        component: () =>
          import(
            /* webpackChunkName: "createModel" */ "@/components/atomic/pages/studio/whatsapp/createModel/index.vue"
          ),
      },
      {
        path: "editar-campanha/:id",
        name: "studio-whatsapp-edit-template",
        props: (route) => ({
          isEdit: route.query.isEdit === "true" || false,
        }),
        component: () =>
          import(
            /* webpackChunkName: "studioWhatsappEditTemplate" */ "@/components/atomic/pages/studio/whatsapp/createModel/index.vue"
          ),
      },
    ],
  },
  {
    path: "/embedded-wa",
    name: "smb",
    component: () =>
      import(
        /* webpackChunkName: "smb" */ "@/components/atomic/pages/embeddedwa/index.vue"
      ),
    meta: {
      showBetaTag: true,
    },
  },
  {
    path: "/input-dados",
    name: "input-data",
    component: () =>
      import(
        /* webpackChunkName: "inputData" */ "@/components/atomic/pages/inputdata/index.vue"
      ),
    meta: {
      showBetaTag: true,
    },
  },
  {
    path: "/perfil-de-compra",
    component: () => {
      return import(
        /* webpackChunkName: "omnichannel" */ "@/components/atomic/pages/purchase-profile/index.vue"
      );
    },
    meta: {
      showBetaTag: true,
    },
  },
  {
    path: "/channels",
    redirect: { name: "channels " },
    name: "all-channels",
    component: () => import("@/components/atomic/pages/channels/index.vue"),
    meta: {
      showDatePicker: false,
      showBetaTag: true,
    },
    children: [
      {
        path: "list",
        name: "channel-list",
        component: () =>
          import("@/components/atomic/pages/channels/list/index.vue"),
      },
      {
        path: "email",
        name: "channel-email",
        component: () =>
          import("@/components/atomic/pages/channels/email/index.vue"),
      },
    ],
  },
  {
    path: "/crm-sellers",
    redirect: { name: "sellers" },
    name: "vendedores",
    component: () =>
      import(
        /* webpackChunkName: "chunkVendedores" */ "@/components/atomic/pages/crm/sellers/index.vue"
      ),
    meta: {
      showDatePicker: false,
      showBetaTag: true,
    },
    children: [
      {
        path: "sellers",
        name: "sellers",
        component: () =>
          import(
            /* webpackChunkName: "sellers" */ "@/components/atomic/pages/crm/sellers/listSellers/index.vue"
          ),
      },
      {
        path: "create-seller",
        name: "create-seller",
        component: () =>
          import(
            /* webpackChunkName: "createSeller" */ "@/components/atomic/pages/crm/sellers/createSeller/index.vue"
          ),
      },
    ],
  },
  {
    path: "/integracoes",
    name: "integrations",
    component: () =>
      import(
        /* webpackChunkName: "integrations" */ "@/components/atomic/pages/integrations/index.vue"
      ),
    meta: {
      showDatePicker: false,
      breadcrumb: "",
    },
    children: [
      {
        path: "",
        name: "your-integrations",
        component: () =>
          import(
            /* webpackChunkName: "yourIntegrations" */ "@/components/atomic/pages/integrations/yourIntegrations/index.vue"
          ),
      },
    ],
  },
  {
    // QUANDO ESTAVEL, REMOVER O TODO O FILHO DE INTEGRAÇÕES ACIMA E REMOVER O V2
    path: "/integracoes-v2",
    name: "integrations-v2",
    component: () =>
      import(
        /* webpackChunkName: "integrationsV2" */ "@/components/atomic/v2/pages/integrations/index.vue"
      ),
    children: [
      {
        path: "",
        name: "list-integrations-v2",
        component: () =>
          import(
            /* webpackChunkName: "listIntegrations" */ "@/components/atomic/v2/pages/integrations/listIntegrations/index.vue"
          ),
      },
      {
        path: "conectadas",
        name: "connected-integrations",
        component: () =>
          import(
            /* webpackChunkName: "connectedIntegrations" */ "@/components/atomic/v2/pages/integrations/connectedIntegrations/index.vue"
          ),
      },
    ],
  },
  {
    path: "/importacoes",
    name: "imports",
    component: () => import("@/components/atomic/pages/list-upload/index.vue"),
    children: [
      {
        path: "lista",
        name: "list",
        component: () =>
          import(
            /* webpackChunkName: "importsList" */ "@/components/atomic/pages/list-upload/list/index.vue"
          ),
      },
      {
        path: "upload",
        name: "upload",
        component: () =>
          import(
            /* webpackChunkName: "importsUpload" */ "@/components/atomic/pages/list-upload/upload/index.vue"
          ),
      },
    ],
    meta: {
      showBetaTag: true,
    },
  },
  {
    path: "/vendas",
    name: "sales",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "@/components/atomic/pages/integrations/sales/index.vue"
      ),
  },
  {
    path: "/waba",
    name: "waba-integration",
    component: () =>
      import(
        /* webpackChunkName: "wabaIntegration" */ "@/components/atomic/v2/pages/integrations/waba/index.vue"
      ),
  },
  {
    path: "/campanhas",
    name: "campaigns",
    component: () =>
      import(
        /* webpackChunkName: "campaigns" */ "@/components/atomic/pages/campaigns/index.vue"
      ),
    meta: {
      showDatePicker: false,
      breadcrumb: "",
    },

    children: [
      {
        path: "email",
        name: "emailCampaigns",
        redirect: { name: "customize-campaigns" },
        component: () =>
          import(
            /* webpackChunkName: "campaignsEmail" */ "@/components/atomic/pages/campaigns/email/index.vue"
          ),
        meta: {
          showDatePicker: false,
          showBetaTag: false,
          breadcrumb: "",
        },

        children: [
          {
            path: "",
            name: "list-campaigns",
            redirect: { name: "customize-campaigns" },
            children: [
              {
                path: "",
                name: "email-sends-campaigns",
                redirect: { name: "customize-campaigns" },
              },
              {
                path: "rascunhos",
                name: "email-draft-campaigns",
                redirect: { name: "customize-campaigns" },
              },
              {
                path: "agendados",
                name: "email-scheduled-campaigns",
                redirect: { name: "customize-campaigns" },
              },
            ],
          },
          {
            path: "",
            name: "email-campaign-sends",
            redirect: { name: "customize-campaigns" },
          },
          {
            path: "criar-campanha",
            name: "email-create-campaigns",
            component: () =>
              import(
                /* webpackChunkName: "createCampaigns" */ "@/components/atomic/pages/campaigns/email/createCampaign/index.vue"
              ),
          },
          {
            path: "editar-campanha/:id",
            name: "email-edit-campaign",
            component: () =>
              import(
                /* webpackChunkName: "createCampaignsEdit" */ "@/components/atomic/pages/campaigns/email/createCampaign/index.vue"
              ),
          },
        ],
      },
      {
        path: "offsite",
        name: "offsite-campaigns",
        redirect: { name: "customize-campaigns" },
        component: () =>
          import(
            /* webpackChunkName: "offsiteCampaigns" */ "@/components/atomic/pages/campaigns/offsite/index.vue"
          ),
        meta: {
          showBetaTag: true,
        },
        children: [
          {
            path: "",
            name: "customize-campaigns",
            component: () =>
              import(
                /* webpackChunkName: "customizeCampaigns" */ "@/components/atomic/pages/campaigns/offsite/customizeCampaigns/index.vue"
              ),
            meta: {
              showBetaTag: true,
            },
          },
          {
            path: "bemax",
            name: "bemax-campaigns",
            component: () =>
              import(
                /* webpackChunkName: "bemaxCampaigns" */ "@/components/atomic/pages/campaigns/offsite/bemaxCampaigns/index.vue"
              ),
            meta: {
              showBetaTag: true,
            },
          },
        ],
      },
      {
        path: "landing-page",
        name: "landing-page",
        redirect: { name: "list-landing-page" },
        component: () =>
          import(
            /* webpackChunkName: "landingPage" */ "@/components/atomic/pages/campaigns/landingPage/index.vue"
          ),
        meta: {
          iframe: true,
        },
        children: [
          {
            path: "",
            name: "list-landing-page",
            component: () =>
              import(
                /* webpackChunkName: "listLandingPage" */ "@/components/atomic/pages/campaigns/landingPage/listLandingPage/index.vue"
              ),
          },
        ],
      },
      {
        path: "sms",
        name: "smsCampaign",
        redirect: { name: "customize-campaigns" },
        component: () =>
          import(
            /* webpackChunkName: "campaignsSms" */ "@/components/atomic/pages/campaigns/sms/index.vue"
          ),
        meta: {
          showDatePicker: false,
          showBetaTag: true,
          breadcrumb: "",
        },
        children: [
          {
            path: "",
            name: "sms-list-campaigns",
            redirect: { name: "customize-campaigns" },
            children: [
              {
                path: "",
                name: "sms-sends-campaigns",
                redirect: { name: "customize-campaigns" },
              },
              {
                path: "rascunhos",
                name: "sms-draft-campaigns",
                redirect: { name: "customize-campaigns" },
              },
              {
                path: "agendados",
                name: "sms-scheduled-campaigns",
                redirect: { name: "customize-campaigns" },
              },
            ],
          },
          {
            path: "",
            name: "sms-campaign-sends",
            redirect: { name: "customize-campaigns" },
          },
          {
            path: "criar-campanha",
            name: "sms-create-campaigns",
            component: () =>
              import(
                /* webpackChunkName: "createCampaignsSms" */ "@/components/atomic/pages/campaigns/sms/create/index.vue"
              ),
          },
          {
            path: "editar-campanha/:id",
            name: "sms-edit-campaign",
            component: () =>
              import(
                /* webpackChunkName: "editCampaignsSms" */ "@/components/atomic/pages/campaigns/sms/create/index.vue"
              ),
          },
        ],
      },
      {
        path: "whatsapp",
        name: "whatsappCampaign",
        redirect: { name: "customize-campaigns" },
        meta: {
          showDatePicker: false,
          showBetaTag: false,
          breadcrumb: "",
        },

        children: [
          {
            path: "",
            name: "whatsapp-list-campaigns",
            redirect: { name: "customize-campaigns" },
            children: [
              {
                path: "",
                name: "whatsapp-sends-campaigns",
                redirect: { name: "customize-campaigns" },
              },
              {
                path: "bemax",
                name: "whatsapp-bemax-campaigns",
                redirect: { name: "customize-campaigns" },
              },
              {
                path: "agendados",
                name: "whatsapp-scheduled-campaigns",
                redirect: { name: "customize-campaigns" },
              },
              {
                path: "rascunhos",
                name: "whatsapp-draft-campaigns",
                redirect: { name: "customize-campaigns" },
              },
            ],
          },
          {
            path: "editar-campanha/:id",
            name: "whatsapp-edit-campaign",
            component: () =>
              import(
                /* webpackChunkName: "campaignsWhatsappSends" */ "@/components/atomic/pages/campaigns/whatsapp/create/index.vue"
              ),
          },
          {
            path: "criar-campanha",
            name: "whatsapp-create-campaigns",
            component: () =>
              import(
                /* webpackChunkName: "createCampaignsWhatsapp" */ "@/components/atomic/pages/campaigns/whatsapp/create/index.vue"
              ),
          },
        ],
      },
    ],
  },
  {
    path: "/jornadas",
    name: "workflow",
    redirect: { name: "list-workflow" },
    component: () =>
      import(
        /* webpackChunkName: "workflow" */ "@/components/atomic/pages/workflow/index.vue"
      ),
    meta: {
      showDatePicker: false,
      showBetaTag: true,
      breadcrumb: "",
    },
    children: [
      {
        path: "",
        name: "list-workflow",
        component: () =>
          import(
            /* webpackChunkName: "listWorkflow" */ "@/components/atomic/pages/workflow/list/index.vue"
          ),
      },
      {
        path: "criar",
        name: "create-workflow",
        component: () =>
          import(
            /* webpackChunkName: "createWorkflow" */ "@/components/atomic/pages/workflow/create/index.vue"
          ),
      },
      {
        path: "editar/:id",
        name: "edit-workflow",
        component: () =>
          import(
            /* webpackChunkName: "editWorkflow" */ "@/components/atomic/pages/workflow/create/index.vue"
          ),
      },
      {
        path: "preview/:id",
        name: "preview-workflow",
        component: () =>
          import(
            /* webpackChunkName: "previewWorkflow" */ "@/components/atomic/pages/workflow/create/index.vue"
          ),
      },
    ],
  },
  {
    path: "/solicitacoes",
    name: "ticket",
    redirect: { name: "list-tickets" },
    component: () =>
      import(
        /* webpackChunkName: "ticket" */ "@/components/atomic/pages/tickets/index.vue"
      ),
    meta: {
      showDatePicker: false,
      showBetaTag: true,
      breadcrumb: "",
    },
    children: [
      {
        path: "",
        name: "list-tickets",
        component: () =>
          import(
            /* webpackChunkName: "listTickets" */ "@/components/atomic/pages/tickets/list/index.vue"
          ),
      },
      {
        path: "criar",
        name: "create-ticket",
        component: () =>
          import(
            /* webpackChunkName: "createTicket" */ "@/components/atomic/pages/tickets/create/index.vue"
          ),
      },
    ],
  },
  {
    path: "/nao-autorizado",
    name: "unauthorized",
    component: () =>
      import(
        /* webpackChunkName: "unauthorized" */ "@/components/atomic/pages/unauthorized/index.vue"
      ),
    meta: {
      showBetaTag: false,
    },
  },
  {
    path: "/historico-consumo",
    name: "historical-consumption",
    component: () =>
      import(
        /* webpackChunkName: "historicalConsumption" */ "@/components/atomic/pages/quicksight/historicalConsumption/index.vue"
      ),
    meta: {
      showBetaTag: true,
    },
    beforeEnter: (to, from) =>
      KeyCloak.permissionPage("historical-consumption"),
  },
  {
    path: "/guru-jornadas",
    name: "insights-journey",
    component: () =>
      import(
        /* webpackChunkName: "insightsJourney" */ "@/components/atomic/pages/bemax/insights-journey/index.vue"
      ),
    meta: {
      showBetaTag: true,
      templateSidebar: "sidebarBemax",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export { routes };

export default router;
